import React from 'react'
import { useAppSeo } from '@core/Utils/hooks/useAppSeo'
import { Deposit } from './Deposit'

export const DepositPage = () => {
  useAppSeo({
    title: 'Deposit | TABtouch',
    description: 'Explore deposit content and betting information with TABtouch.',
  })

  return <Deposit flow='account-deposit' />
}
